// extracted by mini-css-extract-plugin
export default {"fr-view":"Standalone_fr-view__DvbFv","droppable":"Standalone_droppable__likAg","isDraggingOver":"Standalone_isDraggingOver__B0jR1","course":"Standalone_course__t0dHk"};